import React from "react";
import "../styles/forms.css";
import { savePData } from "../requests/req_perfil";
import { getMunicipios } from "../requests/req_general";
import { Col, FormGroup, UncontrolledTooltip } from "reactstrap";
import { notifica } from "../requests/utils";
import {
  getEstadosCivil,
  getGeneros,
  getNacionalidades,
} from "../requests/CatalogosGenerales";
import { format } from "date-fns";

export default class FrmInfoPersonal extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      estados: null,
      municipios: null,
      datos: this.props.datos || {},
      dat_rh: null,
      colonias: null,
      idestado: this.props.datos.idEstado || 0,
      estadosCivil: [],
      generos: [],
      nacionalidades: [],
      fechaNacimiento: "",
    };
    this.editar = this.editar.bind(this);
    this.guardarInf = this.guardarInf.bind(this);
    this.estableceEstados = this.estableceEstados.bind(this);
    this.estableceColonias = this.estableceColonias.bind(this);
    this.editCloseForm = this.editCloseForm.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    getMunicipios((e) => this.estableceEstados(e));
    getEstadosCivil().then((res) => {
      if (this._isMounted) {
        this.setState({ estadosCivil: res });
      }
    });
    getGeneros().then((res) => {
      if (this._isMounted) {
        this.setState({ generos: res });
      }
    });
    getNacionalidades().then((res) => {
      if (this._isMounted) {
        this.setState({ nacionalidades: res });
      }
    });
    this.editar(null, true);

    const { fechaNacimiento } = this.props.datos;
    this.buildDate(fechaNacimiento);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.datos !== this.props.datos) {
      this.setState({ datos: this.props.datos });
    }

    if (prevProps.datos !== this.props.datos) {
      const { fechaNacimiento } = this.props.datos;
      this.buildDate(fechaNacimiento);
    }
  }
  componentWillUnmount() {
    this._isMounted = false;

    localStorage.removeItem("frm_Prfl_IP");
  }
  editCloseForm(data) {
    if (data != null) {
      var Items = JSON.parse(data);
      var primerNombre = document.getElementById("primerNombre");
      var FechaNacim = document.getElementById("FechaNacim");
      var apellidoPaterno = document.getElementById("apellidoPaterno");
      var IdNacionalidad = document.getElementById("IdNacionalidad");
      var apellidoMaterno = document.getElementById("apellidoMaterno");
      var IdGenero = document.getElementById("IdGenero");
      var direccion = document.getElementById("direccion");
      var IdEstadoCiv = document.getElementById("IdEstadoCiv");
      var IdCodigoPostal = document.getElementById("IdCodigoPostal");
      var telefono1 = document.getElementById("telefono1");
      var IdMunicipio = document.getElementById("IdMunicipio");
      var telefono2 = document.getElementById("telefono2");
      var IdEstado = document.getElementById("IdEstado");
      primerNombre.value = Items.nombre !== "" ? Items.nombre : "";
      FechaNacim.value = Items.FechaNacim !== "" ? Items.FechaNacim : "";
      apellidoPaterno.value =
        Items.apellidoPaterno !== "" ? Items.apellidoPaterno : "";
      IdNacionalidad.value =
        Items.IdNacionalidad != null ? Items.IdNacionalidad : "0";
      apellidoMaterno.value =
        Items.apellidoMaterno !== "" ? Items.apellidoMaterno : "";
      IdGenero.value = Items.IdGenero != null ? Items.IdGenero : "0";
      direccion.value = Items.direccion !== "" ? Items.direccion : "";
      IdEstadoCiv.value = Items.IdEstadoCiv != null ? Items.IdEstadoCiv : "0";
      IdCodigoPostal.value =
        Items.IdCodigoPostal !== "" ? Items.IdCodigoPostal : "";
      telefono1.value = Items.telefono1 !== "" ? Items.telefono1 : "";
      IdMunicipio.value = Items.IdMunicipio != null ? Items.IdMunicipio : "0";
      telefono2.value = Items.telefono2 !== "" ? Items.telefono2 : "";
      IdEstado.value = Items.IdEstado != null ? Items.IdEstado : "0";

      var inps = document.querySelectorAll(".frm"),
        btnS = document.getElementById("img_sv_IP");

      var btnEdit = document.getElementById("img_edit_IP");
      btnEdit.classList.add("Hide_All");
      btnS.classList.remove("Hide_All");

      inps.forEach(function (i) {
        i.disabled = false;
      });
    }
  }

  estableceEstados(datos) {
    if (this._isMounted) {
      this.setState({ estados: datos });
    }
  }

  estableceColonias(datos) {
    if (this._isMounted) {
      this.setState({ colonias: datos });
    }
  }

  editar(e, atr) {
    var inps = document.querySelectorAll(".frm"),
      btnS = document.getElementById("img_sv_IP");
    if (e !== null) {
      var elm = e.target;
      elm.classList.add("Hide_All");
      btnS.classList.remove("Hide_All");
    }
    inps.forEach(function (i) {
      i.disabled = atr;
    });
  }

  guardarInf(e, atr) {
    var nombre = document.getElementById("lblNombre");
    var tel = document.getElementById("lbltel1");
    var telefono1 = document.getElementById("telefono1");
    let telefono2 = document.getElementById("telefono2");
    var fechaN = document.getElementById("FechaNacim").value;
    var fot = document.getElementById("inp_arcCV");
    var id = this.props.datos ? this.props.datos.archivoCV : "";
    var direccion = document.getElementById("direccion").value;
    var idEstado = document.getElementById("IdEstado").value;
    var idMunicipio = document.getElementById("IdMunicipio").value;
    let primerNombre = document.getElementById("primerNombre").value;
    let apellidoPaterno = document.getElementById("apellidoPaterno").value;
    let apellidoMaterno = document.getElementById("apellidoMaterno").value;
    let nacionalidad = document.getElementById("IdNacionalidad").value;
    let genero = document.getElementById("IdGenero").value;
    let estCivil = document.getElementById("IdEstadoCiv").value;

    if (genero === "0" || genero === undefined || genero === null) {
      notifica("warning", "Debes introducir tu genero sexual", "Error");
      return;
    }
    if (estCivil === "0" || estCivil === undefined || estCivil === null) {
      notifica("warning", "Debes introducir tu estado civil", "Error");
      return;
    }
    if (
      nacionalidad === "0" ||
      nacionalidad === undefined ||
      nacionalidad === null
    ) {
      notifica("warning", "Debes introducir tu nacionalidad", "Error");
      return;
    }
    if (
      primerNombre === "" ||
      primerNombre === undefined ||
      primerNombre === null
    ) {
      notifica("warning", "Debes introducir tu(s) nombre(s)", "Error");
      return;
    }
    if (
      apellidoMaterno === "" ||
      apellidoMaterno === undefined ||
      apellidoMaterno === null
    ) {
      notifica("warning", "Debes introducir tu apellido materno", "Error");
      return;
    }
    if (
      apellidoPaterno === "" ||
      apellidoPaterno === undefined ||
      apellidoPaterno === null
    ) {
      notifica("warning", "Debes introducir tu apellido paterno", "Error");
      return;
    }

    if (direccion === "" || direccion === undefined || direccion === null) {
      notifica("warning", "Debes introducion la dirección", "Error");
      return;
    }

    if (idEstado === 0 || idEstado === "0") {
      notifica("warning", "Debes introducion el Estado", "Error");
      return;
    }
    //console.log('municipio', idMunicipio)
    if (
      idMunicipio === "" ||
      idMunicipio === undefined ||
      idMunicipio === null ||
      idMunicipio === 0 ||
      idMunicipio === "0"
    ) {
      notifica("warning", "Debes introducion la Ciudad", "Error");
      return;
    }

    if (id === "") {
      if (fot.files[0] === undefined || fot.files[0] === null) {
        notifica("warning", "Debe adjuntar el CV", "Error");
        return;
      }
      if (
        fot.files[0].type !== "application/pdf" &&
        fot.files[0].type !== "application/msword" &&
        fot.files[0].type !==
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        notifica(
          "warning",
          "Solo se permiten archivos '.pdf, .doc, .docx",
          "Error"
        );
        return;
      }
    }

    var arc = fot.files[0];
    if (arc != null) {
      if (
        arc.type !== "application/pdf" &&
        arc.type !== "application/msword" &&
        arc.type !==
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        notifica(
          "warning",
          "Solo se permiten archivos '.pdf, .doc, .docx",
          "Error"
        );
        return;
      }
    }

    if (fechaN === "" || fechaN === null || fechaN === undefined) {
      notifica(
        "warning",
        "La fecha de nacimiento es un campo es obligatorio",
        "Error"
      );
      return;
    }
    let fechaNacimiento = fechaN.split("-");
    let yearActual = new Date().getFullYear();

    if (
      yearActual - parseInt(fechaNacimiento[0]) < 16 ||
      yearActual - parseInt(fechaNacimiento[0]) > 99
    ) {
      notifica("warning", "Fecha de nacimiento no permitida", "Error");
      return;
    }
    if (telefono1.value === "") {
      notifica("warning", "El Numero de celular es obligatorio", "Error");
      return;
    }
    if (telefono2.value === "") {
      notifica("warning", "El Numero de telefonico es obligatorio", "Error");
      return;
    }

    let expTelefono = new RegExp(/^([0-9])*$/);
    if (expTelefono.test(telefono1.value) === false) {
      notifica("warning", "Solo se permiten números", "Error");
      return;
    } else {
      if (telefono1.value.toString().length !== 10) {
        notifica("warning", "Ingresa un número a 10 dígitos", "Error");
        return;
      }
    }

    //Valida CP
    let cp = document.getElementById("IdCodigoPostal").value;
    var expreg = /^[0-9]{5}$/;

    if (cp.length !== 5 || !expreg.test(cp)) {
      notifica(
        "warning",
        "Requerido, el CP debe contener 5 caracteres numericos",
        "Error"
      );
      this.refs.IdCodigoPostal.focus();
      return;
    }

    savePData(this.props.datos, (r) => {
      var btnrefresh = document.getElementById("btnrefresh");
      this.props.handleUpdate && this.props.handleUpdate();
      if (btnrefresh) btnrefresh.click();
    });
    if (nombre) {
      nombre.innerText =
        primerNombre + " " + apellidoPaterno + " " + apellidoMaterno;
    }
    if (tel) {
      telefono1 = document.getElementById("telefono1");
      tel.innerText = telefono1.value;
    }

    var inps = document.querySelectorAll(".frm"),
      btnS = document.getElementById("img_edit_IP"),
      btng = document.getElementById("img_sv_IP");
    if (e !== null) {
      var elm = e.target;
      elm.classList.remove("Hide_All");
      btnS.classList.remove("Hide_All");
      btng.classList.add("Hide_All");
    }
    inps.forEach(function (i) {
      i.disabled = atr;
    });
    var btnrefresh = document.getElementById("btnrefresh");
    if (btnrefresh) btnrefresh.click();
  }

  generaComboEdo(datos) {
    if (datos !== null) {
      return datos.map((i, index) => {
        return (
          <option value={i.idEstado} key={index}>
            {i.estado}
          </option>
        );
      });
    }
  }

  generaComboColonia(datos) {
    if (datos !== null) {
      return datos.data.map((i, index) => {
        return (
          <option value={i.idColonia} key={index}>
            {i.colonia}
          </option>
        );
      });
    }
  }

  generaComboCiud(data, idEstado) {
    const { datos } = this.state;
    if (data !== null) {
      if (datos.idEstado > 0) {
        let newData = data.filter((item) => {
          return item.idEstado === parseInt(datos.idEstado);
        });

        return newData[0].municipios.map((i, index) => {
          return (
            <option value={i.idMunicipio} key={index}>
              {i.municipio}
            </option>
          );
        });
      }
    }
  }

  handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    const { datos } = this.state;
    this.setState({
      datos: {
        ...datos,
        [name]: value,
      },
    });
  };

  resolveNacionalidad() {
    const { datos } = this.state;
    const raw = datos?.idNacionalidad;
    const esNumero = raw !== null && raw !== undefined && raw !== "" && !isNaN(raw);
    if (esNumero) return raw;

    const texto = datos?.nacionalidad;
    if (texto) {
      const match = this.state.nacionalidades.find(
        (item) => String(item.label).toLowerCase() === String(texto).toLowerCase()
      );
      if (match) return match.value;
    }
    return "0";
  }

  buildDate(FechaNacimiento) {
    if (
      FechaNacimiento === null ||
      FechaNacimiento === undefined ||
      FechaNacimiento === ""
    )
      return null;

    let date = new Date();
    if (typeof FechaNacimiento === "string") {
      const arrayF = FechaNacimiento.split("/");
      date = new Date(
        parseInt(arrayF[2]),
        parseInt(arrayF[0]) - 1,
        parseInt(arrayF[1])
      );
    }
    this.setState({ fechaNacimiento: format(date, "yyyy-MM-dd") });
  }

  render() {
    const { datos, generos, fechaNacimiento } = this.state;
    const id = this.props.datos ? this.props.datos.archivoCV : "";

    return (
      <div className="APL_Frm_dv">
        <FormGroup row>
          <Col sm={10} md={10} lg={10} />
          <Col sm={2} md={2} lg={2}>
            <img
              src={window.origin + "/images/icon_edit_1.png"}
              className="img_edit"
              alt="Editar"
              id="img_edit_IP"
              onClick={(e) => this.editar(e, false)}
            />
            <UncontrolledTooltip placement="right" target={"img_edit_IP"}>
              Editar Información Personal
            </UncontrolledTooltip>
            <img
              src={window.origin + "/images/icon_save_2.png"}
              className="img_edit Hide_All"
              alt="Guardar"
              id="img_sv_IP"
              onClick={(e) => this.guardarInf(e, true)}
            />
            <UncontrolledTooltip placement="right" target={"img_sv_IP"}>
              Guardar Cambios
            </UncontrolledTooltip>
          </Col>
          <Col sm={2} md={2} lg={2}>
            <label className="lbl_md">
              Nombre:<span style={{ color: "red" }}>*</span>
            </label>
          </Col>
          <Col sm={4} md={4} lg={4}>
            <input
              type="text"
              className="frm frm_Prfl_IP"
              datsvfrm="nombre"
              name="primerNombre"
              id="primerNombre"
              value={datos?.primerNombre || ""}
              onChange={this.handleChange}
            />
          </Col>
          <Col sm={3} md={3} lg={3}>
            <label className="lbl_md">
              Fecha Nacimiento:<span style={{ color: "red" }}>*</span>
            </label>
          </Col>
          <Col sm={3} md={3} lg={3}>
            <input
              type="date"
              className="frm frm_Prfl_IP"
              datsvfrm="FechaNacim"
              id="FechaNacim"
              value={fechaNacimiento}
              onChange={(event) => {
                this.setState({ fechaNacimiento: event.target.value });
              }}
            />
          </Col>
          <Col sm={2} md={2} lg={2}>
            <label className="lbl_md">
              Apellido Paterno:<span style={{ color: "red" }}>*</span>
            </label>
          </Col>
          <Col sm={4} md={4} lg={4}>
            <input
              type="text"
              className="frm frm_Prfl_IP"
              name="apellidoPaterno"
              datsvfrm="apellidoPaterno"
              id="apellidoPaterno"
              value={datos?.apellidoPaterno || ""}
              onChange={this.handleChange}
            />
          </Col>
          <Col sm={2} md={2} lg={2}>
            <label className="lbl_md">
              Nacionalidad:<span style={{ color: "red" }}>*</span>
            </label>
          </Col>
          <Col sm={4} md={4} lg={4}>
            <select
              name="idNacionalidad"
              className="frm frm_Prfl_IP"
              datsvfrm="IdNacionalidad"
              id="IdNacionalidad"
              value={this.resolveNacionalidad()}
              onChange={this.handleChange}
            >
              <option value="0" disabled>
                Selecciona...
              </option>
              {this.state.nacionalidades.map((item, index) => {
                return (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
          </Col>
          <Col sm={2} md={2} lg={2}>
            <label className="lbl_md">
              Apellido Materno:<span style={{ color: "red" }}>*</span>
            </label>
          </Col>
          <Col sm={4} md={4} lg={4}>
            <input
              type="text"
              className="frm frm_Prfl_IP"
              datsvfrm="apellidoMaterno"
              name="apellidoMaterno"
              id="apellidoMaterno"
              value={datos?.apellidoMaterno || ""}
              onChange={this.handleChange}
            />
          </Col>
          <Col sm={2} md={2} lg={2}>
            <label className="lbl_md">
              Género:<span style={{ color: "red" }}>*</span>
            </label>
          </Col>
          <Col sm={4} md={4} lg={4}>
            <select
              name="idGenero"
              className="frm frm_Prfl_IP"
              datsvfrm="IdGenero"
              id="IdGenero"
              value={datos?.idGenero || "0"}
              onChange={this.handleChange}
            >
              <option value="0" disabled>
                Selecciona...
              </option>
              {generos &&
                generos.map((item, index) => {
                  return (
                    <option value={item.value} key={index}>
                      {item.label}
                    </option>
                  );
                })}
            </select>
          </Col>
          <Col sm={2} md={2} lg={2}>
            <label className="lbl_md">
              Calle y número:<span style={{ color: "red" }}>*</span>
            </label>
          </Col>
          <Col sm={4} md={4} lg={4}>
            <input
              type="text"
              className="frm frm_Prfl_IP"
              datsvfrm="direccion"
              name="direccion"
              id="direccion"
              value={datos.direccion || ""}
              onChange={this.handleChange}
            />
          </Col>
          <Col sm={2} md={2} lg={2}>
            <label className="lbl_md">
              Estado Civil:<span style={{ color: "red" }}>*</span>
            </label>
          </Col>
          <Col sm={4} md={4} lg={4}>
            <select
              className="frm frm_Prfl_IP"
              datsvfrm="IdEstadoCiv"
              name="idEstadoCivil"
              id="IdEstadoCiv"
              value={datos.idEstadoCivil || "0"}
              onChange={this.handleChange}
            >
              <option value="0" disabled>
                Selecciona...
              </option>
              {this.state.estadosCivil.map((item, index) => {
                return (
                  <option value={item.value} key={index}>
                    {item.label}
                  </option>
                );
              })}
            </select>
          </Col>
          <Col sm={2} md={2} lg={2}>
            <label className="lbl_md">
              Código Postal:<span style={{ color: "red" }}>*</span>
            </label>
          </Col>
          <Col sm={4} md={4} lg={4}>
            <input
              type="number"
              className="frm frm_Prfl_IP"
              datsvfrm="IdCodigoPostal"
              name="idCodigoPostal"
              id="IdCodigoPostal"
              ref="IdCodigoPostal"
              value={datos.idCodigoPostal || ""}
              onChange={this.handleChange}
            />
          </Col>
          <Col sm={2} md={2} lg={2}>
            <label className="lbl_md">
              Celular:<span style={{ color: "red" }}>*</span>
            </label>
          </Col>
          <Col sm={4} md={4} lg={4}>
            <input
              type="text"
              className="frm frm_Prfl_IP"
              name="celular"
              datsvfrm="telefono2"
              maxLength={10}
              id="telefono2"
              value={datos.celular || ""}
              onChange={(e)=>{
                if (e.target.value === '') return this.handleChange(e)
                const regex = /^\d*\.?\d+$/;
                if (regex.test(e.target.value)) {
                  this.handleChange(e)
                }
              }}
            />
          </Col>
          <Col sm={2} md={2} lg={2}>
            <label className="lbl_md">
              Estado:<span style={{ color: "red" }}>*</span>
            </label>
          </Col>
          <Col sm={4} md={4} lg={4}>
            <select
              className="frm frm_Prfl_IP"
              datsvfrm="IdEstado"
              name="idEstado"
              id="IdEstado"
              value={datos.idEstado || ""}
              onChange={this.handleChange}
            >
              <option value="0" disabled>
                Selecciona...
              </option>
              {this.generaComboEdo(this.state.estados)}
            </select>
          </Col>

          <Col sm={2} md={2} lg={2}>
            <label className="lbl_md">
              Teléfono:<span style={{ color: "red" }}>*</span>
            </label>
          </Col>
          <Col sm={4} md={4} lg={4}>
            <input
              type="text"
              className="frm frm_Prfl_IP"
              name="telAdicional"
              maxLength={10}
              datsvfrm="telefono1"
              id="telefono1"
              value={datos.telAdicional || ""}
              onChange={(e)=>{
                if (e.target.value === '') return this.handleChange(e)
                const regex = /^\d*\.?\d+$/;
                if (regex.test(e.target.value)) {
                  this.handleChange(e)
                }
              }}
            />
          </Col>
          <Col sm={2} md={2} lg={2}>
            <label className="lbl_md">
              Ciudad:<span style={{ color: "red" }}>*</span>
            </label>
          </Col>
          <Col sm={4} md={4} lg={4}>
            <select
              className="frm frm_Prfl_IP"
              datsvfrm="IdMunicipio"
              name="idMunicipio"
              id="IdMunicipio"
              value={datos.idMunicipio || "0"}
              onChange={this.handleChange}
            >
              <option value="0" disabled>
                Selecciona...
              </option>
              {this.generaComboCiud(this.state.estados, this.state.idestado)}
            </select>
          </Col>

          <Col sm={2} md={2} lg={2}></Col>
          <Col sm={4} md={4} lg={4}></Col>

          <Col sm={4} md={4} lg={4}>
            <label className="lbl_md">Adjuntar CV </label>
            <label className="lbl_sm">: (*.pdf, *.doc)</label>
          </Col>
          <Col sm={8} md={8} lg={8}>
            <input
              type="file"
              className="frm"
              id="inp_arcCV"
              key={"test"}
              accept="application/pdf,application/msword,
  application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            />
          </Col>
          <Col sm={12} md={12} lg={12}>
            <span id="archivoCV"> {id}</span>
          </Col>
        </FormGroup>
      </div>
    );
  }
}
